import { takeEvery, call, put, select, delay } from "redux-saga/effects";

import { getImage, postProcessImage, postProcessImage64 } from "@/services/CustomShapeService";

import Order from "@/redux/models/Order";
import Checkout from "@/redux/models/Checkout";
import MultipleOutputCustomShape from "@/redux/models/MultipleOutputCustomShape";

import { STATUS_FAILED } from "@/constants/custom_shape";
import getApiErrorMessage from "@/utils/getApiErrorMessage";
import { clearMadUnicornId, muTriesCount } from "@/utils/muPersist";
import { captureMessage } from "@/lib/lazySentry";

const muTimeout = (parseInt(process.env.NEXT_PUBLIC_MAD_UNICORN_TIMEOUT, 10) || 14) - 1;

const { getProcessedImage, processImage, create } = MultipleOutputCustomShape.types;

function* processImageSaga(action) {
  try {
    const { file, order_id, design_id, pusher } = action.payload;

    const initialInfo = yield call(
      typeof file == "string" ? postProcessImage64 : postProcessImage,
      {
        file,
        order_id,
        design_id,
      }
    );

    pusher?.(initialInfo?.id);

    yield put(create({ ...initialInfo }));
  } catch (err) {
    console.log(err);

    if (getApiErrorMessage(err)?.original_image?.length > 0)
      captureMessage(getApiErrorMessage(err)?.original_image[0]);

    const { cb } = action.payload;
    if (cb) cb(STATUS_FAILED);
  }
}

function* getProcessedImageSaga(action) {
  try {
    const { muId, cb } = action.payload;

    const madUnicornCount = muTriesCount.get();

    const processedInfo = yield call(getImage, { id: muId });

    if (processedInfo?.children?.length === 0) {
      if (!(madUnicornCount >= muTimeout)) {
        muTriesCount.set(madUnicornCount + 1);

        yield delay(1000);
        yield put(getProcessedImage({ muId, cb }));
      } else throw new Error("AI timeout");
    } else {
      muTriesCount.remove();

      for (const child of processedInfo.children) {
        yield put(
          create({
            ...child,
            design_id: processedInfo?.design_id,
            order_id: processedInfo?.order_id,
          })
        );
      }

      if (cb) cb();
    }
  } catch (err) {
    console.log(err);
    muTriesCount.remove();

    const { id: order_id } = yield select(Order.selectors.getOrder);
    const design_id = yield select(Checkout.selectors.getSelectedDesign);
    clearMadUnicornId(order_id, design_id);

    if (getApiErrorMessage(err)?.original_image?.length > 0)
      captureMessage(getApiErrorMessage(err)?.original_image[0]);

    const { cb } = action.payload;
    if (cb) cb(STATUS_FAILED);
  }
}

export default function* watchCustomShape() {
  yield takeEvery(processImage().type, processImageSaga);
  yield takeEvery(getProcessedImage().type, getProcessedImageSaga);
}
